import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  comment: string;
}

const LeaveComment = ({ comment }: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box
        sx={{
          fontSize: "16px",
          fontWeight: 400,
          color: "rgba(0, 0, 0, 0.52)",
          margin: "20px 0px 10px 0px",
        }}
      >
        {t("hourEntries:absenceTalentComment")}
      </Box>
      {comment || ""}
    </Box>
  );
};

export default LeaveComment;
